export default "__VITE_ASSET__6jFxZYRL__"